














import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import TypeItem from "@/components/classBuilder/TypeItem.vue";
import {Type} from "@/models/Type/Type";
import {StyleService} from "@/services/StyleService";
import {get} from "@/context/context";
import {TypeService} from "@/services/TypeService";
import {TypeListRequest} from "@/models/Type/TypeListRequest";

@Component({
  components: {
    TypeItem
  },
})
export default class TypesList extends Vue {
  private typeService: TypeService = get('typeService');

  private items:Array<Type> = [];
  private selectedId:string = '';

  @Prop({default: false})
  private child!: boolean;

  @Prop()
  private parentId?: string;

  @Watch('parentId')
  watchPropParentId() {
    this.getTypesList();
  }

  private mounted() {
    this.getTypesList();
  }

  private handleSelected(typeId: string) {
    this.selectedId = typeId;
    this.$emit('selected', typeId);
  }

  private async getTypesList() {
    if (this.child && this.parentId) {
      this.items = await this.typeService.getList({
        parent_id: this.parentId
      });
    }
    if (!this.child) {
      this.items = await this.typeService.getList();
    }
  }
}
